export default __webpack_public_path__ + "static/media/product-people.bf0c03f9.svg";